var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartPie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.03 18.87H22.285a2.133 2.133 0 01-2.135-2.135V4.991c0-1.181.961-2.149 2.129-1.995 7.14.947 12.798 6.606 13.746 13.746.153 1.167-.814 2.128-1.995 2.128zM14.692 5.338c1.208-.254 2.255.734 2.255 1.968v13.166c0 .373.134.734.367 1.02L26.13 32.13c.78.941.614 2.363-.46 2.943a15.94 15.94 0 01-7.654 1.948C9.173 37.02 2 29.847 2 21.006c0-7.707 5.438-14.14 12.692-15.668zM31.72 22.073h4.27c1.235 0 2.223 1.048 1.969 2.256a15.955 15.955 0 01-4.644 8.287c-.821.781-2.109.614-2.83-.26l-5.631-6.786c-1.155-1.395-.16-3.497 1.641-3.497h5.225z"
  })));
}
export default SvgChartPie;